import { useState } from 'react';

interface Product {
  id: string;
  name: string;
  category: string;
  image: string;
  description: string;
  nutrition: {
    servingSize: string;
    calories: number;
    protein: string;
    carbs: string;
    fiber: string;
    sugar: string;
    fat: string;
    sodium: string;
    vitaminC?: string;
    potassium?: string;
    iron?: string;
    calcium?: string;
  };
  packaging: {
    size: string;
    type: string;
    shelfLife: string;
    price: string;
  }[];
  tags: string[];
  origin: string;
  process: string;
}

interface ProductCardProps {
  product: Product;
  isSelected: boolean;
  onClick: () => void;
}

export default function ProductCard({ product, isSelected, onClick }: ProductCardProps) {
  return (
    <div
      onClick={onClick}
      className={`rounded-2xl overflow-hidden cursor-pointer transition-all duration-300 border-2 ${
        isSelected
          ? 'border-amber-600 shadow-xl scale-[1.02]'
          : 'border-transparent shadow-md hover:shadow-lg hover:scale-[1.01]'
      } bg-white`}
    >
      <div className="w-full h-52 overflow-hidden">
        <img
          src={product.image}
          alt={product.name}
          className="w-full h-full object-cover object-top"
        />
      </div>
      <div className="p-5">
        <span className="text-xs font-semibold uppercase tracking-widest text-amber-700 bg-amber-50 px-3 py-1 rounded-full">
          {product.category}
        </span>
        <h3 className="text-lg font-bold text-gray-900 mt-3 mb-1">{product.name}</h3>
        <p className="text-sm text-gray-500 leading-relaxed line-clamp-2">{product.description}</p>
        <div className="flex flex-wrap gap-2 mt-3">
          {product.tags.map((tag) => (
            <span key={tag} className="text-xs text-gray-500 bg-gray-100 px-2 py-1 rounded-md">
              {tag}
            </span>
          ))}
        </div>
        <div className="mt-4 flex items-center justify-between">
          <span className="text-xs text-gray-400">Origin: <strong className="text-gray-600">{product.origin}</strong></span>
          <span className={`text-xs font-semibold px-3 py-1 rounded-full ${isSelected ? 'bg-amber-600 text-white' : 'bg-gray-100 text-gray-600'}`}>
            {isSelected ? 'Viewing Details' : 'View Details'}
          </span>
        </div>
      </div>
    </div>
  );
}

export type { Product };
